<template>
  <Modal :value="value" :width="380" :closable="false" footer-hide
    class="line-modal vertical-center-modal" @on-visible-change="onVisible">
    <div class="ls">
      <div class="ls-head">
        <span class="ls-title">线路切换</span>
        <label class="ls-auto" @click="toggleAuto">
          <i class="dot" :class="{ on: auto }"></i>自动匹配
        </label>
      </div>
      <div class="ls-list">
        <div v-for="(l, i) in lines" :key="i" class="ls-row"
          :class="{ sel: !auto && sel === i }" @click="pick(i)">
          <i class="radio" :class="{ on: !auto && sel === i }"></i>
          <span class="name">{{ l.name }}</span>
          <span class="bars"><b></b><b></b><b></b><b></b></span>
        </div>
      </div>
      <p v-if="auto" class="ls-hint">已开启自动匹配，系统会帮您自动选择最优网络</p>
      <div class="ls-foot">
        <span class="fbtn cancel" @click="close">取消</span>
        <span class="fbtn ok" @click="confirm">确认</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LineSwitchDialog',
  props: { value: { type: Boolean, default: false } },
  data() {
    return { auto: true, sel: 0 }
  },
  computed: { ...mapState(['lines', 'currentLine']) },
  watch: {
    value(v) { if (v) this.sel = this.currentLine }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.$emit('input', false) },
    toggleAuto() { this.auto = !this.auto },
    pick(i) { this.auto = false; this.sel = i },
    confirm() {
      if (!this.auto) this.$store.commit('setCurrentLine', this.sel)
      this.$Message.success(this.auto ? '已开启自动匹配' : `已切换至${this.lines[this.sel].name}`)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
.ls-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.ls-title { font-size: 17px; font-weight: 600; color: #333; }
.ls-auto { display: inline-flex; align-items: center; gap: 6px; color: #333; cursor: pointer; font-size: 14px; }
.ls-auto .dot { width: 15px; height: 15px; border-radius: 50%; border: 1px solid #bbb; box-sizing: border-box; }
.ls-auto .dot.on { border-color: #2d8cf0; background: radial-gradient(#2d8cf0 40%, #fff 46%); }
.ls-list { display: flex; flex-direction: column; gap: 12px; }
.ls-row { display: flex; align-items: center; gap: 10px; background: #f4f5f7; border-radius: 8px;
  padding: 14px 14px; cursor: pointer; border: 1px solid transparent; }
.ls-row.sel { border-color: #2d8cf0; background: #ecf5ff; }
.ls-row .radio { width: 15px; height: 15px; border-radius: 50%; border: 1px solid #bbb; box-sizing: border-box; flex-shrink: 0; }
.ls-row .radio.on { border-color: #2d8cf0; background: radial-gradient(#2d8cf0 40%, #fff 46%); }
.ls-row .name { flex: 1; color: #333; }
.ls-row .bars { display: inline-flex; align-items: flex-end; gap: 2px; height: 16px; }
.ls-row .bars b { width: 3px; background: #3ac26a; border-radius: 1px; }
.ls-row .bars b:nth-child(1) { height: 5px; }
.ls-row .bars b:nth-child(2) { height: 8px; }
.ls-row .bars b:nth-child(3) { height: 12px; }
.ls-row .bars b:nth-child(4) { height: 16px; }
.ls-hint { color: #999; font-size: 13px; margin: 12px 2px 0; line-height: 1.6; }
.ls-foot { display: flex; margin-top: 16px; border-top: 1px solid #eee; }
.ls-foot .fbtn { flex: 1; text-align: center; padding: 12px 0; cursor: pointer; font-size: 16px; }
.ls-foot .cancel { color: #666; border-right: 1px solid #eee; }
.ls-foot .ok { color: #2d8cf0; font-weight: 600; }
</style>
